import { Component } from '@angular/core';
import { PlayListBannerComponent } from '../playlistbanner-component/playlistbanner-component';
import { TimeBannerComponent } from '../timebanner-component/timebanner-component';
/**
 * @title Basic use of the tab group
 */
@Component({
  selector: 'headerbanner-component',
  templateUrl: './headerbanner-component.html',
  styleUrls: ['./headerbanner-component.css'],
  standalone: true,
  imports: [PlayListBannerComponent, TimeBannerComponent],
})
export class HeaderBannerComponent  {



  constructor() { }

  ngOnInit() {
    // Start the interval and subscribe to it
  }


}